<template>
    <content-wrapper>
        <Content class="mt-3">
            <b-card header-bg-variant="dark">
                <template #header>
                    <b-row class="align-items-center justify-content-between text-nowrap">
                        <b-col>
                            <h6 class="mb-0">Retry BSIMS</h6>
                        </b-col>
                        <b-col md="2">
                            <!-- Hidden -->
                            <!-- <div class="d-flex justify-content-end">
                                <b-button variant="outline-light" @click.prevent="openAutoRetryModal()">
                                    <b-icon icon="plus-circle-fill"></b-icon>&nbsp;&nbsp;
                                    Auto
                                </b-button>
                            </div> -->
                        </b-col>
                    </b-row>
                </template>

                <b-row class="mb-3 align-items-stretch">
                    <!-- Dropdown -->
                    <b-col cols="12" md="4" class="mb-2 mb-md-0 pr-md-1">
                        <b-form-select
                        v-model="searchType"
                        :options="searchOptions"
                        ></b-form-select>
                    </b-col>

                    <!-- Input + Button Search -->
                    <b-col cols="12" md="6" class="mb-2 mb-md-0 px-md-1">
                        <b-input-group>
                        <b-form-input
                            placeholder="Keywords"
                            v-model="searchKeywords"
                            @keyup.enter="handleSearch"
                        />
                        <b-input-group-append>
                            <b-button variant="primary" @click="handleSearch">
                            <b-icon icon="search" />
                            </b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-col>

                    <!-- Reset -->
                    <b-col cols="12" md="2" class="pl-md-1">
                        <b-button class="w-100 text-nowrap" variant="outline-secondary" @click="resetSearch">
                        Reset
                        </b-button>
                    </b-col>
                </b-row>
                
                <!-- PERMIT TABLE  -->
                <b-table ref="table"
                        id="table"
                        :per-page="pagination.per_page"
                        :current-page="pagination.current_page"
                        :items="loadPage"
                        :fields="columns"
                        :busy.sync="isLoading"
                        striped
                        borderless
                        outlined
                        hover
                        show-empty
                        empty-text="No records found..."
                        stacked="sm"
                        class="mb-3"
                >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                    <b-spinner label="Loading..." type="grow"></b-spinner>
                    </div>
                </template>
                <template #cell(no)="data">
                    {{ (pagination.current_page - 1) * pagination.per_page + data.index + 1 }}
                </template>
                <template #cell(lic_plate)="data">
                    {{ data.item.lic_plate != null ? data.item.lic_plate : '' }}
                    <b-badge variant="warning" v-if="data.item.company != null" >
                    {{ data.item.company }}
                    </b-badge>
                </template>
                <template #cell(gate_permit)="data">
                
                    <span v-if="typeof data.item.gate_permit === 'object'" >
                    <span v-for="(con, idx) in ([].concat(data.item.gate_permit.containers))" :key="idx">
                            {{ con.container }}&nbsp;
                            <b-badge variant="info">{{ con.voyage }}</b-badge>
                    </span>
                    </span>

                </template>
                <template #cell(lane)="data">
                    <span v-if="data.item.lane == 'in01' || data.item.lane == 'in02'">
                        <div class="badge badge-sm badge-primary">{{ data.item.lane }}</div>
                    </span>
                    <span v-else-if="data.item.lane == 'out01' || data.item.lane == 'out02'">
                        <div class="badge badge-sm badge-danger">{{ data.item.lane }}</div>
                    </span>
                </template>
                <template #cell(actions)="data">
                    <b-button squared variant="info" class="flex-grow-1 btn-sm text-nowrap" @click="showQRModal(data.item)">
                        <b-spinner v-if="isLoading" small></b-spinner>
                        &nbsp;Retry&nbsp;
                    </b-button>
                </template>
                </b-table>

                <!-- pagination -->
                <div class="d-flex justify-content-center">
                    <laravel-pagination
                        :pagination="pagination"
                        @change="changePage"
                        />
                </div>

            </b-card>
        </Content>
        
        <!-- QRModal Old 1 QR -->
        <b-modal header-bg-variant="success"
            id="qrModal2_old"
            ref="qrOld"
            :title="(`${selectedPermitModal2.company===undefined || selectedPermitModal2.company == null ?'': selectedPermitModal2.company.toUpperCase()} - `) + (selectedPermitModal2.lic_plate===undefined?'':selectedPermitModal2.lic_plate.toUpperCase())"
            ok-only
            no-close-on-backdrop>
            
            <h4 class="text-center text-bold text-uppercase">
            {{ selectedPermitModal2.company }}
            </h4>
            <h2 class="text-center">
            {{ selectedPermitModal2.permit_date.replace(/\+.*/, '') }}
            </h2>
            <h1 class="text-center text-uppercase text-bold">
            {{ `${selectedPermitModal2.direction}`}}

            </h1>
            <b-link target="_blank" :href="qrcode" @click="copyToClipboard(selectedPermitModal2.pass_code)">
            <b-img :src="`static/qrcode/${qrcode}`" fluid center></b-img>
            </b-link>
            <h1 class="text-center text-bold text-uppercase">
            {{ selectedPermitModal2.lic_plate }}
            </h1>
            <h2 class="text-center text-uppercase" v-if="selectedPermitModal2.containers!==undefined">
                <ul class="list-group list-group-flush" v-if="selectedPermitModal2.containers!==null">
                <li class="list-group-item" v-for="(container, idx) in selectedPermitModal2.containers.container" :key="idx">
                {{ container.container_no }}  <span class="text-lg">{{ container.voyage }}</span>
                </li>
            </ul>
            </h2>
            <h5 class="text-center" v-else>
            -
            </h5>

            <template #modal-footer="{ ok, }">
                <div class="d-flex w-100" style="gap: 10px;">

                    <b-button variant="danger" class="flex-grow-1" @click.prevent="retryBSIMS(selectedPermitModal2)"> 
                        <b-spinner v-if="isLoading" small></b-spinner>
                        &nbsp;Retry BSIMS&nbsp;
                    </b-button>

                    <b-button @click="
                        qrcode=null;
                        selectedPermitModal2={lic_plate: '',container: '', direction: '', permit_date: '', vessel: '', expired: ''};
                        ok();" 
                        variant="primary"
                        class="flex-grow-1">
                        Cancel
                    </b-button>
                    
                </div>
            </template>
        </b-modal>

        <!-- Modal Auto Retry BSIMS ALL -->
        <b-modal
            v-model="showAutoRetryModal"
            id="autoRetryModal"
            ref="autoRetryModal"
            title="Auto Retry"
            hide-header-close
            centered
            ok-title="Execute"
            ok-variant="danger"
            cancel-title="Cancel"
            @ok="autoRetryConfirmed"
            >
            <div class="text-center">
                <b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="2"></b-icon>
                <h4 class="mt-3 text-danger font-weight-bold">RETRY BSIMS for ALL ?</h4>

                <p class="text-danger mb-0">This action <b>cannot be undo</b> !</p>
            </div>
        </b-modal>

    </content-wrapper>
</template>

<script>
import {
  BIcon,
  BInputGroup, BFormInput,
} from "bootstrap-vue";
import {listRetry, retryBSIMS, retryBSIMSall} from "@/services/retry";
import {hasOwnProperty} from "@/helpers/Utils";
import LaravelPagination from "@/components/LaravelPagination";

export default {
    name: "Retry",
    components: {
        LaravelPagination,
        BIcon, BInputGroup, BFormInput
    },
    
    data() {
        return {
            isLoading: false,
            searchType: 'container',
            searchOptions:[
                {value: 'container', text: 'Container'},
                {value: 'qrcode', text: 'QR-Code'},
            ],
            searchKeywords: '',
            columns: [
                {
                    key: 'no',
                    label: 'No',
                },
                {
                    key: 'evt_time',
                    label: 'Time',
                    formatter: x => typeof x === 'string' ? x.replace(/\+.*/, '') : '-',
                },
                {
                    key: 'lane',
                    label: 'Gate',
                },
                {
                    key: 'lic_plate',
                    label: 'No. Polisi',
                },
                {
                    key: 'gate_permit',
                    label: 'Container [voy]',
                },
                {
                    key: 'actions',
                    label: 'Actions',
                }
            ],
            qrcode:'',
            selectedPermitModal2:{
                lic_plate: '',
                containers: {
                    container: [],
                },
                permit_date: '',
                direction: '',
                company: '',
                vessel: '',
                expired: '',
            },
            pagination: { // based on Laravel pagination response
                current_page: 1,
                first_page_url: '',
                from: 1,
                last_page: 1,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 13,
                prev_page_url: '',
                to: 10,
                total: 10,
            },
            filters: {},
            showAutoRetryModal: false,
        };
    },
    methods: {
        async loadPage(){
            try {
                const payload = {
                    ...this.pagination,
                    ...this.filters,
                };
                const list_retry = JSON.parse(await listRetry(payload)).event_ids;
                // const list_retry = JSON.parse(await listRetry(payload));
                console.log('list_retry',list_retry);
                
                this.pagination = {
                    current_page: list_retry.current_page,
                    first_page_url: list_retry.first_page_url,
                    from: list_retry.from,
                    last_page: list_retry.last_page,
                    last_page_url: list_retry.last_page_url,
                    links: list_retry.links,
                    next_page_url: list_retry.next_page_url,
                    path: list_retry.path,
                    per_page: list_retry.per_page,
                    prev_page_url: list_retry.prev_page_url,
                    to: list_retry.to,
                    total: list_retry.total,
                }
                
                return list_retry.data || [];
            } catch (error) {
                console.error("loadPage error", error);
                return [];
            }
        },
        resetSearch() {
            this.searchType = 'container';
            this.searchKeywords = '';
            this.filters = {};
            this.pagination.current_page = 1; // reset
            this.$refs.table.refresh();
        },
        handleSearch() {
            console.log('Searching for:', this.searchType, this.searchKeywords, this.pagination.current_page);
            this.pagination.current_page = 1; // reset
            this.filters = {
                [this.searchType]: this.searchKeywords,
            };
            this.$refs.table.refresh();
        },
        changePage(page) {
            this.pagination.current_page = page;
            this.$refs.table.refresh();
        },
        openAutoRetryModal() {
            this.showAutoRetryModal = true;
            console.log("Open Auto Retry Modal");
        },
        async autoRetryConfirmed() {
            console.log('Auto Retry BSIMS for ALL confirmed');

            const retryAll = JSON.parse(await retryBSIMSall()); 
            console.log('retryAll', retryAll);

            this.$bvToast.toast(`Auto Retry BSIMS for ALL On Progress`, {
                title: 'Info',
                autoHideDelay: 1500,
                variant: 'info',
            });
        },
        showQRModal(permit) {
            this.isLoading = true;
            
            if (!hasOwnProperty(permit, 'qr_code')) {
                this.$bvToast.toast(`QRCode does not exists`, {
                title: 'Error!',
                autoHideDelay: 1500,
                variant: 'danger',
                })
                this.isLoading = false;
                return;
            }
            
            console.log('permit',permit);
            this.clearForm();
            this.qrcode = permit.qr_code || '';
            this.selectedPermitModal2.pass_code = permit.id;
            this.selectedPermitModal2.id = permit.id;
            this.selectedPermitModal2.lic_plate = permit.lic_plate;
            this.selectedPermitModal2.permit_date = permit.evt_time;
            this.selectedPermitModal2.direction = permit.lane;
            this.selectedPermitModal2.company = permit.gate_permit && permit.gate_permit.member 
                ? permit.gate_permit.member.company_name : '';

            // reset containers to avoid duplicates
            this.selectedPermitModal2.containers = { container: [] };
            if (permit.gate_permit && permit.gate_permit.containers) {
                const containers = Array.isArray(permit.gate_permit.containers) ? permit.gate_permit.containers : [permit.gate_permit.containers];
                containers.forEach((el) =>{
                    if (!el) return;
                    console.log('el',el);
                    this.selectedPermitModal2.containers.container.push({
                        container_no: el.container,
                        voyage: el.voyage,
                    });
                });
            }

            console.log('this.selectedPermitModal2',this.selectedPermitModal2);
            
            this.$nextTick(() => {
                this.isLoading = false;
                this.$bvModal.show('qrModal2_old');
                return;
            });
        },
        async retryBSIMS(event){
            this.isLoading = true;

            // const result = {code: '00', message: 'Simulated success'};
            const result = JSON.parse(await retryBSIMS(event));

            console.log('Retry BSIMS:', result);

            if(result.code === '00'){
                this.$bvToast.toast(`Retry BSIMS Success`, {
                    title: 'Success!',
                    autoHideDelay: 1500,
                    variant: 'success',
                });
                this.isLoading = false;
                this.$refs.qrOld.hide();
                this.clearForm();
                this.$refs.table.refresh();
            } else {
                this.$bvToast.toast(`Retry BSIMS Failed: ${result.message || '500'}`, {
                    title: 'Error!',
                    autoHideDelay: 3000,
                    variant: 'danger',
                });
                this.isLoading = false;
            }
        },
        clearForm(){
            this.selectedPermitModal2 = {
                lic_plate: '',
                containers: {
                    container: [],
                },
                permit_date: '',
                direction: '',
                company: '',
                vessel: '',
                expired: '',
            };
            this.qrcode = '';
        }
    },
    mounted() {
        // pastikan loadPage selalu dipanggil dengan konteks Vue instance
        this.loadPage = this.loadPage.bind(this);
        this.loadPage();
    }
};
</script>